<template>
    <q-menu
        ref="js-timesheet-panel"
        content-class="c-timesheet-panel"
        :square="true"
        :no-parent-event="true"
        :no-focus="true"
        :data-component-name="$options.name"
    >
        <TimeSheetComponent v-if="!foreman && !timereport"/>
        <TimeSheetForemanComponent v-if="foreman"/>
        <TimeReportComponent v-if="timereport"/>
    </q-menu>
</template>

<script>
	import TimeSheetComponent from "@/components/nav/TimeSheet.vue"
    import TimeSheetForemanComponent from "@/components/nav/TimeSheetForeman.vue"
    import TimeReportComponent from "@/components/nav/TimeReport.vue"

    export default {
        name: 'TimeSheetPanel',
        components: { TimeSheetComponent, TimeSheetForemanComponent, TimeReportComponent },
        //props: {
        //	props1:{
        //		type: String,
        //		default: 'Value',
        //	},
        //},
        data(){
        	return {
                isOpened: false,
                foreman: false,
                timereport: false
        	}
        },
        mounted(){
            this.$eventBus.$on('toggle-timesheet-panel', function () {
                this.foreman = false;
                this.$refs['js-timesheet-panel'].show();
            }.bind(this))
            this.$eventBus.$on('toggle-timesheet-foreman-panel', function(){
                this.foreman = true;
                this.timereport = false;
                this.$refs['js-timesheet-panel'].show();
            }.bind(this))
            this.$eventBus.$on('toggle-timereport-panel', function(){
                this.foreman = false;
                this.timereport = true;
                this.$refs['js-timesheet-panel'].show();
            }.bind(this))
        },
        beforeDestroy(){
            this.$eventBus.$off('toggle-timesheet-panel');
            this.$eventBus.$off('toggle-timesheet-foreman-panel');
        },
        computed: {
            currentRoute: function () {
                if (this.$route.path.split('/')[1] == "settings") return "settings";
                return this.$route.name;
            }
        },
        //watch: {},
        //methods: {},
    }
</script>
